/**
 * @file The named queries a report may hold: every `NAMED_QUERY_IDS` entry except those whose rows
 * would push a stored run towards Firestore's 1 MiB document limit, `projectsByStage` with its form
 * lists, and the three series entries, which take a grain and a group a report does not carry.
 * `parseAnalyticsReportDefinition` refuses any other id, so a stored definition naming one
 * becomes one failed run, and the Report form offers only these. A `cloud_run/analytics` test ties
 * the list to `NAMED_QUERIES`, so a new query is reportable unless it is excluded here.
 */
import { NAMED_QUERY_IDS } from './Analytics.NamedQuery.types';
import type { NamedQueryId } from './Analytics.NamedQuery.types';

const UNREPORTABLE_QUERY_IDS = ['projectsByStage', 'bookedSeries', 'ordersWrittenSeries', 'quotesIssuedSeries'] as const satisfies readonly NamedQueryId[];

type ReportableQueryId = Exclude<NamedQueryId, (typeof UNREPORTABLE_QUERY_IDS)[number]>;

const isReportable = (query: NamedQueryId): query is ReportableQueryId => !UNREPORTABLE_QUERY_IDS.some((unreportable) => unreportable === query);

export const ANALYTICS_REPORT_QUERY_IDS: readonly ReportableQueryId[] = NAMED_QUERY_IDS.filter(isReportable);
